import { Activity } from '@cms-max/medicare-api-sdk'
import generator, { EventMapKeys } from './baseGenerator'

export const preventiveServicesGenerator = generator(({ i18n }) => {
  return ({
    // Preventive Services learn more click
    ps_learncoverage_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: 'Preventive Services',
        elementId: 'ps_learncoverage_click'
      }
    },
    // My Preventive Services print click
    ps_print_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: 'Preventive Services',
        elementId: 'ps_print_click'
      }
    },
    // Preventive Services back to home click
    ps_backtoaccounthome_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: 'Preventive Services',
        elementId: 'ps_backtoaccounthome_click'
      }
    },
    // Preventive Services get details click
    ps_getdetails_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: 'Preventive Services',
        elementId: 'ps_getdetails_click'
      }
    },
    // Preventive Services on load
    ps_on_load: {
      core: {
        property: 'MAX',
        activity: Activity.PageLoad,
        component: 'Preventive Services'
      }
    }
  })
})

export type preventiveServicesKeys = EventMapKeys<typeof preventiveServicesGenerator>

export default preventiveServicesGenerator
